import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { WorklistService } from '../worklist.service';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { ParameterService } from '../../../shared/services/parameter/parameter.service';

@Component({
  selector: 'app-worklist-update',
  templateUrl: './worklist-update.component.html',
  styleUrl: './worklist-update.component.scss'
})
export class WorklistUpdateComponent implements OnInit, OnChanges {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() work: any;
  teamsOptions: any[] = [];
  priorityOptions: any[] = [];
  statusOptions: any[] = [];
  @Output() workUpdated = new EventEmitter<any>();

  @Input() disabled?: boolean = false;

  form: FormGroup;

  statusLogsVisible = false;
  statusLogs: any[] = [];

  minWorkDate: Date | null = null;

  @Input() triggerStatusLogs? = false;
  constructor(private readonly fb: FormBuilder,
    private readonly service: WorklistService,
    private readonly messageService: AppMessageService,
    private readonly parameterService: ParameterService,

  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      workDate: [null, Validators.required],
      alarmClokDate: [null, Validators.required],
      priority: [null],
      teams: [[], Validators.required],
      status: [null]
    },
      {
        validators: [workDateAfterAlarmTimeValidator()] // Burada validator'ı ekledik
      });
  }

  ngOnInit(): void {
    if (this.work) {
      this.loadParameterOptions();
      this.form.patchValue(this.work);
    }
  }

  loadParameterOptions() {
    this.parameterService
      .getParameterValues('data-group', 'teams')
      .subscribe((res) => {
        this.teamsOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'statuses')
      .subscribe((res) => {
        this.statusOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'priority')
      .subscribe((res) => {
        this.priorityOptions = res?.datas?.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data?.valueObject.id.value };
        });
      });
  }

  ngOnChanges(): void {
    if (this.work) {
      this.form.patchValue(this.work);
      this.loadParameterOptions();

      const alarmDate =
        this.work.alarmClokDate ??
        this.work.alarmClockDate ??
        this.work.alarmTime ??
        null;

      const workDate =
        this.work.workDate ?? this.work?.workDateTime ??
        null;

      setTimeout(() => {
        this.form.patchValue({
          ...this.work,
          workDate: new Date(workDate) ?? null,
          alarmClokDate: new Date(alarmDate) ?? null,
          isRecurring: this.work.isRecurring === true || this.work.isRecurring === 'true',
        });
      });
    }
    if (this.triggerStatusLogs && this.work) {
      this.openStatusLogsDialog();
    }
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.value;

    const updatedData = {
      ...this.work,
      ...formValue,
      workDate: formValue.workDate,
      alarmClokDate: formValue.alarmClokDate,
    };

    this.service.update(this.work.id, updatedData).subscribe({
      next: (response: any) => {
        this.workUpdated.emit(response.data);
        this.messageService.successToast("", response.message);

        this.visibleChange.emit(false);
      },
      error: (err) => {
        const message =
          err?.error?.message ??
          err?.message ?? ''
        this.messageService.errorToast("", message);
      }
    })

  }

  cancel() {
    this.visibleChange.emit(false);
    this.form.reset();
  }

  openStatusLogsDialog() {
    this.service.getStatusLogs(this.work.id).subscribe({
      next: (res) => {
        this.statusLogs = res.data.statusLogs

        this.statusLogsVisible = this.statusLogs.length > 0;
        this.visible = false;
        res.data.statusLogs.length > 0 ? this.messageService.successToast("", res.message) : this.messageService.errorToast("", res.message)

      },
      error: (err) => {
        const message =
          err?.error?.message ??
          err?.message ?? ''
        this.messageService.errorToast("", message);
      }
    })
  }

  closeStatusLogsDialog() {
    this.statusLogsVisible = false;
    this.statusLogs = [];
    this.form.reset();


  }

  onAlarmTimeChange() {
    const alarmTime = this.form.get('alarmClokDate')?.value;
    if (alarmTime) {
      this.minWorkDate = new Date(alarmTime); // tarih + saat
    }
  }


  get workDateBeforeAlarmTimeError(): boolean {
    return !!(
      this.form.errors?.['workBeforeAlarm'] &&
      (this.form.get('workDate')?.touched ?? this.form.get('alarmTime')?.touched)
    );
  }
}

export function workDateAfterAlarmTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const workDate = control.get('workDate')?.value;
    const alarmTime = control.get('alarmClokDate')?.value;

    if (workDate && alarmTime) {
      const workDateTime = new Date(workDate).getTime();
      const alarmDateTime = new Date(alarmTime).getTime();

      if (workDateTime < alarmDateTime) {
        return { workBeforeAlarm: true };
      }
    }
    return null;
  };
}
